import React from 'react';

import { ErrorMessageWrapper } from './styles';
import { ErrorMessageProps } from './types';

const ErrorMessage = ({ children, ...restProps }: ErrorMessageProps) => {
  return <ErrorMessageWrapper {...restProps}>{children}</ErrorMessageWrapper>;
};
export default ErrorMessage;
